(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/quickplay-modal/assets/javascripts/hooks/use-pix-data.js') >= 0) return;  svs.modules.push('/components/sport/quickplay-modal/assets/javascripts/hooks/use-pix-data.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }


const {
  useEffect,
  useCallback
} = React;
const logger = new svs.core.log.Logger('svs.sport.QuickplayModal');
const {
  helpers: {
    isFulltraff,
    isRacing,
    isMaltipset,
    isBomben
  }
} = svs.utils.products;
const {
  cache,
  helpers: {
    useAsyncSafeState
  },
  hooks
} = svs.components.sport.quickplayModal;
const {
  Currency: formatCurrency
} = svs.utils.format;
const _getPixItemCacheKey = _ref => {
  let {
    drawNumber,
    isPixMix,
    productId,
    systemType,
    systemCost
  } = _ref;
  return "pix_".concat(productId, "_").concat(drawNumber, "_").concat(formatCurrency(systemCost)).concat(isPixMix ? "_pixmix" : '').concat(systemType ? "_".concat(systemType) : '');
};

function usePixData(_ref2) {
  let {
    productId,
    drawData,
    isPixMix,
    raceData,
    systemCost,
    systemType,
    rowPrice,
    onError
  } = _ref2;
  const [normalizedData, setNormalizedData] = useAsyncSafeState(null);
  const _doAsync = useCallback(_ref3 => {
    let {
      shouldIgnoreCache,
      onError2,
      systemCost
    } = _ref3;
    const handleError = error => {
      logger.info("usePixData() failed with \"".concat(error === null || error === void 0 ? void 0 : error.message, "\" (productId ").concat(productId, ", shouldIgnoreCache ").concat(shouldIgnoreCache, ")"));
      if (onError2) {
        onError2(error);
      }
    };
    return refreshPixAsync({
      drawData,
      handleError,
      isPixMix,
      productId,
      raceData,
      rowPrice,
      setNormalizedData,
      shouldIgnoreCache,
      systemCost,
      systemType
    });
  }, [drawData, isPixMix, productId, raceData, rowPrice, setNormalizedData, systemType]);
  useEffect(() => {
    _doAsync({
      shouldIgnoreCache: false,
      onError2: onError,
      systemCost
    });
  }, [_doAsync, onError, systemCost]);
  const refreshPix = useCallback(inputBag => {
    _doAsync({
      shouldIgnoreCache: true,
      onError2: inputBag === null || inputBag === void 0 ? void 0 : inputBag.onError,
      systemCost: inputBag === null || inputBag === void 0 ? void 0 : inputBag.systemCost
    });
  }, [_doAsync]);
  return normalizedData === null ? null : _objectSpread(_objectSpread({}, normalizedData), {}, {
    refreshPix
  });
}

async function refreshPixAsync(_ref4) {
  let {
    drawData,
    handleError,
    isPixMix,
    productId,
    raceData,
    rowPrice,
    setNormalizedData,
    shouldIgnoreCache,
    systemCost,
    systemType
  } = _ref4;
  try {
    const drawNumber = (drawData === null || drawData === void 0 ? void 0 : drawData.drawNumber) || (raceData === null || raceData === void 0 ? void 0 : raceData.drawNumber);
    if (productId && drawNumber && systemCost && rowPrice) {
      const cacheKey = _getPixItemCacheKey({
        drawNumber,
        isPixMix,
        productId,
        systemType,
        systemCost
      });
      if (shouldIgnoreCache) {
        setNormalizedData(null);
      } else {
        const cachedData = cache.getData({
          itemKey: cacheKey
        });
        if (cachedData) {
          setNormalizedData(cachedData);
          return;
        }
      }
      let normalizedData = null;
      if (isFulltraff(productId)) {
        const rawData = await hooks.queryFulltraffPixAsync({
          drawNumber,
          systemCost
        });
        normalizedData = hooks.normaliseFulltraffPix({
          data: rawData,
          productId,
          drawNumber,
          systemCost,
          systemType
        });
      } else if (isRacing(productId)) {
        const {
          numberOfParticipants,
          subProductId
        } = raceData || {};
        const rawData = await hooks.queryRacingPixAsync({
          drawNumber,
          systemCost,
          rowPrice
        });
        normalizedData = hooks.normaliseRacingPix({
          data: rawData,
          productId,
          drawNumber,
          systemCost,
          rowPrice,
          numberOfParticipants,
          subProductId,
          systemType
        });
      } else if (isMaltipset(productId)) {
        var _drawData$events;
        const amountEvents = drawData === null || drawData === void 0 || (_drawData$events = drawData.events) === null || _drawData$events === void 0 ? void 0 : _drawData$events.length;
        const rawData = await hooks.queryMaltipsPixAsync({
          productId,
          drawNumber,
          systemCost,
          systemType
        });
        normalizedData = hooks.normaliseMaltipsPix({
          data: rawData,
          productId,
          drawNumber,
          systemCost,
          systemType,
          amountEvents
        });
      } else if (isBomben(productId)) {
        var _drawData$events2;
        const amountEvents = drawData === null || drawData === void 0 || (_drawData$events2 = drawData.events) === null || _drawData$events2 === void 0 ? void 0 : _drawData$events2.length;
        const rawData = await svs.components.sport.quickplayModal.hooks.queryBombenPixAsync({
          productId,
          drawNumber,
          systemCost,
          rowPrice
        });
        normalizedData = svs.components.sport.quickplayModal.hooks.normaliseBombenPix({
          data: rawData,
          productId,
          drawNumber,
          systemCost,
          amountEvents,
          systemType
        });
      } else {
        var _drawData$events3;
        const amountEvents = drawData === null || drawData === void 0 || (_drawData$events3 = drawData.events) === null || _drawData$events3 === void 0 ? void 0 : _drawData$events3.length;
        const rawData = await svs.components.sport.quickplayModal.hooks.queryTipsPixAsync({
          productId,
          drawNumber,
          systemCost,
          rowPrice
        });
        normalizedData = svs.components.sport.quickplayModal.hooks.normaliseTipsPix({
          data: rawData,
          productId,
          drawNumber,
          systemCost,
          amountEvents,
          systemType
        });
      }
      if (normalizedData) {
        const TTL_24H = 60 * 1000 * 1440;
        cache.setData(_objectSpread({
          itemKey: cacheKey,
          data: normalizedData
        }, isPixMix ? {
          ttl: TTL_24H
        } : {}));
        setNormalizedData(normalizedData);
      }
    }
  } catch (error) {
    handleError(error);
  }
}

function unsetPixFromCache(_ref5) {
  let {
    pixData
  } = _ref5;
  const {
    drawNumber,
    isPixMix,
    productId,
    systemType,
    systemCost
  } = pixData || {};
  if (productId && drawNumber) {
    const cacheKey = _getPixItemCacheKey({
      drawNumber,
      isPixMix,
      productId,
      systemType,
      systemCost
    });
    cache.unsetData({
      itemKey: cacheKey
    });
  }
}
setGlobal('svs.components.sport.quickplayModal.hooks', {
  usePixData,
  unsetPixFromCache,
  refreshPixAsync
});

 })(window);